export default __webpack_public_path__ + "static/media/11 Track 11.e535b991.mp3";